import Vue from "vue";
import es from "vuetify/es5/locale/es";
import '@mdi/font/css/materialdesignicons.css'
import Vuetify, { VSnackbar, VBtn, VIcon } from 'vuetify/lib'
import VuetifyToast from 'vuetify-toast-snackbar';

Vue.use(Vuetify, { components: {
  VSnackbar,
  VBtn,
  VIcon
} })
Vue.use(VuetifyToast);

export default new Vuetify( {
  theme: {
    themes: {
      light: {
        primary: "#0e345b",
        accent: "#5585bf",
        secondary: "#f0efed"
      },
    },
  },
  icons: {
    iconfont: "mdiSvg",
    // iconfont: 'mdi',
  },
  lang: {
    locales: { es },
    current: "es"
  }
});
